import { render } from "./SvgMagnifyingGlass.vue?vue&type=template&id=4c447c32&ts=true"
import script from "./SvgMagnifyingGlass.vue?vue&type=script&lang=ts"
export * from "./SvgMagnifyingGlass.vue?vue&type=script&lang=ts"

import "./SvgMagnifyingGlass.vue?vue&type=style&index=0&id=4c447c32&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__